import { ComponentsRoutingModule } from "./modules/components-routing.moule";
import { NgxPaginationModule } from "ngx-pagination";
import { BrowserModule } from "@angular/platform-browser";
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import {
  HttpClientModule,
  HttpBackend,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxSpinnerModule } from "ngx-spinner";
import { HeaderComponent } from "./core/header/header.component";
import { LoginComponent } from "./modules/pages/login/login.component";
import {
  BrowserAnimationsModule,
  NoopAnimationsModule,
} from "@angular/platform-browser/animations";
import { DeploymentModule } from "./modules/deployment/deployment.module";
import { JobModule } from "./modules/job/job.module";
import { StorageModule } from "./modules/storage/storage.module";
import { CoreModule } from "./core/core.module";
import { NodeModule } from "./modules/node/node.module";
import { SyncHpcModule } from "./modules/synchpc/synchpc.module";
import { ApplicationModule } from "./modules/application/application.module";
import { UserModule } from "./modules/user/user.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SyncConfigService } from "./core/services/sync-config.service";
import { MatStepperModule } from "@angular/material/stepper";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { LicenseServerModule } from "./modules/license-server/license-server.module";
import { GatewayModule } from "./modules/gateway/gateway.module";
import { SharedModule } from "./modules/shared/shared.module";
import { MatTableModule } from "@angular/material/table";
import { SessionModule } from "./modules/session/session.module";
import { EnvironmentService } from "./core/services/environment.service";
import { GoogleChartsModule } from "angular-google-charts";
import {
  MsalModule,
  MsalRedirectComponent,
  MsalService,
} from "@azure/msal-angular";
import { NgxGaugeModule } from "ngx-gauge";
import { AngularMaterialModule } from "./shared/material-module";
import { LogInUiConfigService } from "./core/services/logInUiConfig.service";
import { DesktopClientModule } from "./modules/desktop-client/desktop-client.module";
import { OktaAuthModule } from "@okta/okta-angular";
import { ConfiguratorModule } from "./modules/pages/configurator/configurator.module";
import { AuthClientConfig, AuthModule } from "@auth0/auth0-angular";
import { AppConfigService } from "./core/services/auth-config.service";
import { CredentialModule } from "./modules/credential/credential.module";
import { ImagesModule } from "./modules/images/images.module";
import { MenuComponent } from "./core/components/menu/menu.component";
import { HealthComponent } from "./modules/health/health.component";
import { MatTabsModule } from "@angular/material/tabs";
import { EntitySettingComponent } from "./modules/entity-setting/entity-setting.component";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatDialogModule } from "@angular/material/dialog";
import { MarkdownModule } from "ngx-markdown";
import { DocumentComponent } from "./modules/pages/document/document.component";
import { NumberToStringPipe } from "./core/pipes/number-to-string.pipe";
import { HealthLogsComponent } from "./modules/health/health-logs/health-logs.component";
import { HealthServicesComponent } from "./modules/health/health-services/health-services.component";
import { HealthNetworkComponent } from "./modules/health/health-network/health-network.component";
import { HealthSystemInfoComponent } from "./modules/health/health-system-info/health-system-info.component";
import { DbServerInfoComponent } from "./modules/health/db-server-info/db-server-info.component";
import { ConfiguratorRoutingModule } from "./modules/pages/configurator/configurator-routing.module";
import { AnalyticsModule } from "./modules/analytics/analytics.module";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { LocalRepoModule } from "./modules/local-repo/local-repo.module";
import { AuthConfig, OAuthModule, OAuthService } from "angular-oauth2-oidc";
import { PING_IDENTITY_CONFIG } from "./core/models/ping-auth-config.token";
import { JWTErrorInterceptor } from "./core/interceptors/jwt-error-interceptor.service";
import { UserDepAccessInterceptor } from "./core/interceptors/user-dep-access.interceptor";
import { AuthJwtInterceptorService } from "./core/interceptors/jwt-auth-interceptor.service";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    MenuComponent,
    DocumentComponent,
    EntitySettingComponent,
    HealthComponent,
    HealthLogsComponent,
    HealthServicesComponent,
    HealthNetworkComponent,
    HealthSystemInfoComponent,
    DbServerInfoComponent
  ],
  imports: [
    OAuthModule.forRoot(),
    ImagesModule,
    CredentialModule,
    ConfiguratorModule,
    MatStepperModule,
    CoreModule,
    ApplicationModule,
    DeploymentModule,
    AnalyticsModule,
    JobModule,
    NodeModule,
    GatewayModule,
    LicenseServerModule,
    StorageModule,
    SyncHpcModule,
    UserModule,
    DesktopClientModule,
    BrowserModule,
    SessionModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AngularMaterialModule,
    NoopAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule.forRoot({ type: "ball-spin" }),
    CommonModule,
    NgxPaginationModule,
    BrowserModule,
    NgbModule,
    SharedModule,
    MatTableModule,
    MatDialogModule,
    GoogleChartsModule,
    OktaAuthModule,
    MsalModule,
    AuthModule.forRoot(),
    NumberToStringPipe,
    ComponentsRoutingModule,
    NgxGaugeModule,
    MatTabsModule,
    MatSlideToggleModule,
    LocalRepoModule,
    MarkdownModule.forRoot(),
    //Keep at lowest place
    AppRoutingModule,
    ConfiguratorRoutingModule,
    NgxMatSelectSearchModule
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeOAuth,
      deps: [OAuthService, PING_IDENTITY_CONFIG],
      multi: true
    },
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
        return new Promise((resolve) => {
          resolve(true);
        });
      },
      deps: [AppConfigService],
      multi: true,
    },
    EnvironmentService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFnEnv,
      multi: true,
      deps: [EnvironmentService],
    },
    LogInUiConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFnLogInUI,
      multi: true,
      deps: [LogInUiConfigService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthJwtInterceptorService,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: JWTErrorInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UserDepAccessInterceptor,
      multi: true,
    },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
    MsalService,
    SyncConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [SyncConfigService],
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {}

function appInitializerFn(appConfig: SyncConfigService) {
  return () => {
    return appConfig.loadAppConfig();
  };
}

function appInitializerFnEnv(environmentValues: EnvironmentService) {
  return () => {
    return environmentValues.loadEnvConfig();
  };
}

function appInitializerFnLogInUI(logInUiConfigValues: LogInUiConfigService) {
  return () => {
    return logInUiConfigValues.loadLogInUiConfig();
  };
}

export function initializeOAuth(
  oauthService: OAuthService,
  config: AuthConfig,
  environmentValues: EnvironmentService
): () => Promise<any> {
  return () => {
    oauthService.configure(config);
    oauthService.loadDiscoveryDocument();
    oauthService.tryLogin();
    return Promise.resolve();
  };
}

function openIdFn(handler: HttpBackend, config: AuthClientConfig) {
  return () => {
    return new HttpClient(handler)
      .get("assets/config/openid.json")
      .toPromise()
      .then((loadedConfig: any) => {
        config.set(loadedConfig);
      });
  };
}
